import { registerHelpAgentWidget } from './register';

export { HelpAgentApp, HelpAgentIcon, registerHelpAgentWidget } from './register';

registerHelpAgentWidget();

export { DEFAULT_QUICK_PROMPTS } from './constants/quick-prompts';
export type { HelpAgentQuickPromptList } from './constants/quick-prompts';
export { DEFAULT_ATTACHMENT_POLICY, normalizeAttachmentPolicy } from './constants/attachment-policy';
export { DEFAULT_HELP_CENTER_FOOTER_LINKS, resolveHelpCenterFooterLinks } from './utils/help-center-links';
export type { ChatConfig, ChatImage, ChatMessage } from './types/chat';
export type { HelpCenterFooterLinks } from './utils/help-center-links';
export type {
  HelpAgentCloseDetail,
  HelpAgentElement,
  HelpAgentExpandedChangeDetail,
  HelpAgentNewChatDetail,
  HelpAgentNotificationDetail,
  HelpAgentStreamCleanup,
  HelpAgentStreamHandler,
  HelpAgentStreamRequest,
  HelpAgentWidgetEventMap,
  HelpAgentWidgetConfig,
  HelpAgentWidgetProps,
} from './types/public';
export type {
  HelpAgentAttachmentPolicy,
  HelpAgentAttachmentPreview,
  HelpAgentDraftAttachment,
  HelpAgentAttachmentKind,
  HelpAgentAttachmentRejection,
  HelpAgentSubmitHandler,
  HelpAgentSubmitRequest,
  HelpAgentSubmitResult,
} from './types/attachments';

export const HELP_AGENT_TAG_NAME = 'help-agent-app';
